import React, { useState, useEffect } from 'react';
import styles from './copyright.module.scss';
function Copyright() {
  return <p className={styles.LoginPage__copyright}>Copyright © Kuwait India Exchange. All Rights Reserved.</p>;
}

export { Copyright };
